import { userService } from '@libs/data-access/queries'
import { IconButton, InformationCircleBoldIcon, Tooltip } from '@libs/ui/ds'
import { usePlanningFormTranslation } from '@libs/utils/translations'
import { useMemoSelector } from '@spa/redux/hooks'
import React from 'react'
import { getCurrentAccount } from 'snap-redux/modules/accounts/selectors'

export const MatriculInfoIcon = () => {
  const { t } = usePlanningFormTranslation()
  const account = useMemoSelector(getCurrentAccount)

  const permissions = userService.membership.useFeaturePermissions()

  if (!permissions?.hr_silae_hr_synchronisation?.can_read) {
    return null
  }
  return (
    <Tooltip
      label={
        account.automatically_generate_employee_ids
          ? t('membershipCreation.employeeId.tooltipAutoId')
          : t('membershipCreation.employeeId.tooltip')
      }
    >
      <IconButton
        icon={<InformationCircleBoldIcon />}
        size='s'
        variant='tertiary'
        intent='neutral-dark'
      />
    </Tooltip>
  )
}
